/**
 * SGKC023A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SpecificationGetInfo {

    /**
     * 契約お客さま番号
     */
    firstSrvctrNo?: string;
    /**
     * 料金算定年月
     */
    chargeCalcYm?: string;
}

